import React, { useEffect } from 'react'
import Header from './components/Header';
import { auth } from './api/Utility';
import { useNavigate } from 'react-router-dom';
const FrontLayout = ({ cmp, darkMode, setDarkMode }) => {
    const Component = cmp;
    const navigate = useNavigate()
    useEffect(() => {
        if (!auth()) {
            navigate('/login');
        }
    }, [])
    return (
        <>
            <Header darkMode={darkMode} setDarkMode={setDarkMode} />
            <Component />
        </>
    )
}

export default FrontLayout